import React from "react";
import {Route, Switch} from "react-router-dom";

// General:
import Login from "../auth/Login/Login";
import {Alert, ReduxProtectedRoute} from "@leap4/frontend";
import {requiredAuthRoles, BACKEND_SERVICE_NAME} from "../../config/generals";
import {urlService} from "./urlsService";
import {HomePage} from "../modules/home/home";


const Routes = () => {

    return (
        <section className="container">
            <Alert/>
            <Switch>
                <Route exact path="/login" component={Login}/>

                {/************** Home *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={HomePage} path={urlService.home()}/>

                <Route component={Login}/>
            </Switch>
         </section>
    )
};

export default Routes;
